// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_3iJ3o","tooltip-icon":"F6AxG","tooltip-message":"fSZ+P","right":"i-iSb","left":"jsOJ3","bottom":"-L8no"};